// extracted by mini-css-extract-plugin
module.exports = {"breakpointMD":"750px","breakpointLG":"1250px","breakpointXL":"1800px","element":"ContentRollerText-module--element--15SfE","loading":"ContentRollerText-module--loading--Y6pcQ"};